import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { CountdownBannerBase } from "@faire/retailer-visitor-shared/components/CountdownBanner/__internal__/CountdownBannerBase";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { useEventsStore } from "@faire/retailer-visitor-shared/stores/domain/Events/shared/EventsStore";
import { ThemeProvider } from "@faire/web--source/slate/Theme/ThemeProvider";
import { Typography } from "@faire/web--source/slate/Typography";
import { AlertBanner } from "@faire/web--source/ui/AlertBanner";
import React, { useState } from "react";
export var CountdownBanner = function(param) {
    var textColor = param.textColor, renderDaysBeforeDeadlineView = param.renderDaysBeforeDeadlineView, renderHoursBeforeDeadlineView = param.renderHoursBeforeDeadlineView, renderLoggedOutView = param.renderLoggedOutView, centerAlignIcon = param.centerAlignIcon;
    var nextOrActiveEventTheme = useEventsStore([
        "nextOrActiveEventTheme"
    ]).nextOrActiveEventTheme;
    var _useMarketStore = useMarketStore([
        "deadlineForCountdownBanner",
        "hasCountdownEnded"
    ]), deadline = _useMarketStore.deadlineForCountdownBanner, hasCountdownEnded = _useMarketStore.hasCountdownEnded;
    var _useState = _sliced_to_array(useState(function() {
        return !hasCountdownEnded;
    }), 2), showCountdown = _useState[0], setShowCountdown = _useState[1];
    if (!showCountdown) {
        return null;
    }
    return /*#__PURE__*/ _jsx(ThemeProvider, {
        theme: nextOrActiveEventTheme,
        children: /*#__PURE__*/ _jsx(AlertBanner, {
            message: /*#__PURE__*/ _jsx(Typography, {
                color: textColor,
                children: /*#__PURE__*/ _jsx(CountdownBannerBase, {
                    deadline: deadline,
                    daysBeforeDeadlineView: renderDaysBeforeDeadlineView,
                    hoursBeforeDeadlineView: renderHoursBeforeDeadlineView,
                    loggedOutView: renderLoggedOutView,
                    onCountdownChange: function() {
                        return setShowCountdown(!hasCountdownEnded);
                    }
                }, "".concat(deadline))
            }),
            centerAlignIcon: centerAlignIcon
        })
    });
};
